import script from "./PedidosFiltros.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidosFiltros.vue?vue&type=script&setup=true&lang=js"

import "./PedidosFiltros.vue?vue&type=style&index=0&id=a7ecae0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7ecae0c"]])

export default __exports__